<form
  *ngIf="form && initialized"
  [formGroup]="form"
  (ngSubmit)="submit()"
  class="p-fluid">
  <app-header icon="fas fa-palette" text="Farben"></app-header>
  <div class="grid">
    <app-colorset-dropdown
      [colSize]="5"
      formControlName="colorset"></app-colorset-dropdown>
  </div>

  <p-divider />

  <app-header icon="fas fa-sliders" text="Linien und Punkte" />
  <div class="grid">
    <div class="col-4">
      <label class="mb-2 inline-block">Transparenz</label>

      <app-ngx-slider
        labelCeil="gering"
        labelFloor="hoch"
        [options]="{ ceil: 1, floor: 0, step: 0.1 }"
        formControlName="featureOpacity"></app-ngx-slider>
    </div>
    <div class="col-4">
      <label class="mb-2 inline-block">Punktgröße</label>

      <app-ngx-slider
        labelFloor="klein"
        labelCeil="groß"
        [options]="{ ceil: 4, floor: 0.5, step: 0.2 }"
        formControlName="dotSize"></app-ngx-slider>
    </div>
    <div class="col-4">
      <label class="mb-2 inline-block">Linienverlauf</label>

      <app-ngx-slider
        labelFloor="gerade"
        labelCeil="kurve"
        [options]="{ ceil: 1, floor: 0, step: 0.1 }"
        formControlName="lineTension"></app-ngx-slider>
    </div>
  </div>

  <app-header icon="fas fa-a" text="Beschriftung"></app-header>
  <div class="grid">
    <app-form-field-wrapper
      [hideLabel]="true"
      [floatingLabel]="false"
      [name]="'displayValues'"
      [colSize]="6">
      <p-checkbox
        [binary]="true"
        label="Werte einblenden"
        name="displayValues"
        formControlName="displayValues"></p-checkbox>
    </app-form-field-wrapper>
  </div>
</form>
